$(document).ready(function() {
  var cartNoItems = $("#dropdown-cart").find(".no-items"),
        cartHasItems = $("#dropdown-cart").find(".has-items");
  
  var sidebarCart = $("#sidebar-cart"),
    btnRemove = sidebarCart.find(".btn-remove"),
    sidebarCartNoItems = sidebarCart.find(".cart-empty"),
    sidebarCartHasItems = sidebarCart.find(".mini-products-list"),
    sidebarCartFooter = sidebarCart.find(".cart-footer");

  if ($(".mini-products-list").children().length) {
    cartHasItems.show();
    cartNoItems.hide();

    sidebarCartNoItems.hide();
    sidebarCartHasItems.show();
    sidebarCartFooter.show();
  } else {
    //cartHasItems.hide();
    cartNoItems.show();

    sidebarCartNoItems.show();
    //sidebarCartHasItems.hide();
    sidebarCartFooter.hide();
  }

  function ResizeCart() {
    $("html").removeClass("cart-show");
    $("#dropdown-cart").appendTo($("body"));
  }
  
  $(window).on("resize", function (e) {
    ResizeCart();
  });

  ResizeCart();

  $(document).click(function (e) {
    if (!$(e.target).closest("#dropdown-cart").length && !$(e.target).is("#dropdown-cart") ) {
       $("html").removeClass("cart-show");        
    }
  });

  
  $("body:not(.template-cart) [data-cart-toggle]").click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    $("html").toggleClass("cart-show");
    //$('.side-cart-upsell-list.slick-initialized').slick('unslick');
    //$('.side-cart-upsell-list').slick(window.swiperUpsellConfig);
    checkIfNoItemsDropdownCart();
    let sliderforswiper = new Swiper(".side-cart-upsell-list", {
      speed: 400,
      spaceBetween: 5,
      slidesPerView: 2,
      slidesPerGroupSkip: 2,
      grabCursor: true,
      parallax: true,
      
      
      navigation: {
        nextEl: '.side-cart-upsell-list .swiper-button-next',
        prevEl: '.side-cart-upsell-list .swiper-button-prev',
      },
    });
  });
});